/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DashboardSpiderUseCase } from './DashboardSpiderUseCase';
import {
  DashboardSpiderUseCaseFromJSON,
  DashboardSpiderUseCaseFromJSONTyped,
  DashboardSpiderUseCaseToJSON,
} from './DashboardSpiderUseCase';

/**
 *
 * @export
 * @interface DashboardSpiderUseCases
 */
export interface DashboardSpiderUseCases {
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderUseCases
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderUseCases
   */
  maxCount: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderUseCases
   */
  restValue: number | null;
  /**
   *
   * @type {Array<DashboardSpiderUseCase>}
   * @memberof DashboardSpiderUseCases
   */
  results: Array<DashboardSpiderUseCase>;
}

/**
 * Check if a given object implements the DashboardSpiderUseCases interface.
 */
export function instanceOfDashboardSpiderUseCases(value: object): value is DashboardSpiderUseCases {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('maxCount' in value) || value['maxCount'] === undefined) return false;
  if (!('restValue' in value) || value['restValue'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function DashboardSpiderUseCasesFromJSON(json: any): DashboardSpiderUseCases {
  return DashboardSpiderUseCasesFromJSONTyped(json, false);
}

export function DashboardSpiderUseCasesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardSpiderUseCases {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    maxCount: json['max_count'],
    restValue: json['rest_value'],
    results: (json['results'] as Array<any>).map(DashboardSpiderUseCaseFromJSON),
  };
}

export function DashboardSpiderUseCasesToJSON(value?: DashboardSpiderUseCases | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    max_count: value['maxCount'],
    rest_value: value['restValue'],
    results: (value['results'] as Array<any>).map(DashboardSpiderUseCaseToJSON),
  };
}
